import { DateTime } from 'luxon';

export function utcToLocalDate(date: string): DateTime {
	return DateTime.fromISO(date);
}

export function dateToIso(date?: string): any {
	if (!date || date === '') {
		return null;
	}
	const dateTime = DateTime.fromJSDate(new Date(date)).toUTC();
	return dateTime.toISO();
}

export function dateToIsoEndOfDay(date?: string): any {
	if (!date || date === '') {
		return null;
	}
	let dateTime = DateTime.fromJSDate(new Date(date)).toUTC();
	dateTime = dateTime.set({hour: 23});
	dateTime = dateTime.set({minute: 59});
	dateTime = dateTime.set({second: 59});
	return dateTime.toISO();
}

export function dateToIsoStartOfDay(date?: string): any {
	if (!date || date === '') {
		return null;
	}
	let dateTime = DateTime.fromJSDate(new Date(date)).toUTC();
	dateTime = dateTime.set({hour: 0});
	dateTime = dateTime.set({minute: 0});
	dateTime = dateTime.set({second: 0});
	return dateTime.toISO();
}

export function dateToIsoMantainTime(date?: string): any {
	if (!date || date === '') {
		return null;
	}
	let dateTime = DateTime.fromJSDate(new Date(date)).toUTC();
	return dateTime.toISO();
}

export function dateTableFormat(date: string): string {
	console.log('date', date);
	return utcToLocalDate(date).toFormat('dd/MM/yyyy');
}

export function dateTimeTableFormat(date: string): string {
	return utcToLocalDate(date).toFormat('dd/MM/yyyy HH:mm:ss');
}

export function secondsToHms (d: number): string {
	var h = Math.floor(d / 3600);
	var m = Math.floor(d % 3600 / 60);
	var s = Math.floor(d % 3600 % 60);

	var hDisplay = h > 0 ? h + (h == 1 ? " ora" : " ore") : "";
	var mDisplay = m > 0 ? m + (m == 1 ? " minuto" : " minuti") : "";
	var sDisplay = s > 0 ? s + (s == 1 ? " secondo" : " secondi") : "";
	if (hDisplay === '' && mDisplay === '' && sDisplay === '') {
		return '-';
	} else {
		let ret = hDisplay;
		if (hDisplay !== '' && (mDisplay !== '' || sDisplay !== '')) {
			ret += ', ';
		}
		ret += mDisplay;
		if (mDisplay !== '' && sDisplay !== '') {
			ret += ', ';
		}

		ret += sDisplay;

		return ret;
	}
}

export function getLastFiveYears() {
	const yearNow = DateTime.now().get('year');
	let yearList = [yearNow];

	for (let i = 1; i < 6; i++) {
		const year = yearNow - i;
		yearList.push(year);
	}
	return yearList
}
